"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CARET_HEIGHT = exports.CARET_WIDTH = exports.ICON_SIZES = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var DEPRECIATED_ICON_SIZES = {
  xxs: 16,
  xs: 24,
  sm: 48,
  md: 64,
  lg: 72,
  xl: 96,
  xxl: 128
};
var ICON_SIZES = (0, _extends2.default)({
  small: 16,
  medium: 32,
  large: 48
}, DEPRECIATED_ICON_SIZES);
exports.ICON_SIZES = ICON_SIZES;
var CARET_WIDTH = 11.5;
exports.CARET_WIDTH = CARET_WIDTH;
var CARET_HEIGHT = 21.1;
exports.CARET_HEIGHT = CARET_HEIGHT;